module.exports = __webpack_public_path__ + "static/media/AvatarKyrillos.f30d578f.png";